import { searchEstimateWithReject, } from "@erp/shared/api/generated/wrappers/estimate";
import { withLoading } from "@erp/shared/utils/loading/with-loading";
import { searchCardDefaultInputs } from "../_components/Search/const";
import { defineStore } from "pinia";
import { ref } from "vue";
export const useEstimateCardInputs = defineStore("useEstimate-searchInput", () => {
    const searchInputs = ref(searchCardDefaultInputs);
    const searchRes = ref([]);
    const setByLabel = (label, value) => {
        const input = searchInputs.value.find((x) => x.label === label);
        if (!input) {
            console.warn(`label "${label}" 항목을 찾을 수 없습니다.`);
            return;
        }
        input.value = value;
    };
    const setsearchInputs = (inhouseBidNumber, companyBidNumber, companyName, issueDate) => {
        if (!searchInputs.value || searchInputs.value.length <= 0)
            return;
        if (searchInputs.value[0].value === "All") {
            searchInputs.value[0].value = "";
        }
        setByLabel("사내 견적번호", inhouseBidNumber);
        setByLabel("기업별 입찰번호", companyBidNumber);
        setByLabel("업체명", companyName);
        const dateValue = issueDate.includes(" ~ ")
            ? issueDate.split(" ~ ")
            : [issueDate, issueDate];
        setByLabel("발행일", dateValue);
    };
    const search = async () => {
        if (searchInputs.value[0].value === "All") {
            searchInputs.value[0].value = "";
        }
        withLoading(async () => {
            searchRes.value = await searchEstimateWithReject(searchInputs.value);
        });
    };
    return { searchRes, searchInputs, setsearchInputs, search };
});
